import React from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import FormField from "../fields/FormField";
import Label from "../../../atoms/label/Label";

class CheckboxInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(field, form) {
    const { name, value, onChange } = this.props;
    let nextValue = [];

    if (field.value.includes(value)) {
      nextValue = field.value.filter(val => val !== value);
    } else {
      nextValue = field.value.concat(value);
    }

    onChange(nextValue);
    form.setFieldValue(name, nextValue);
  }

  render() {
    const {
      name,
      id,
      label,
      classes,
      containerClasses,
      value,
      children,
      required,
      disabled
    } = this.props;

    return (
      <FormField
        name={name}
        classes={`form-item form-item--checkbox ${containerClasses}`}
      >
        <Field classes={classes} name={name}>
          {({ field, form }) => (
            <input
              type="checkbox"
              id={id}
              disabled={disabled}
              required={required}
              {...field}
              checked={field.value.includes(value)}
              onChange={event => this.onChange(field, form, event)}
            />
          )}
        </Field>
        <Label
          classes="form-item__label form-item__label--checkbox option"
          text={label}
          id={id}
          required={required}
        />
        {children}
      </FormField>
    );
  }
}

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.string,
  containerClasses: PropTypes.string,
  classes: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  required: PropTypes.bool
};

CheckboxInput.defaultProps = {
  containerClasses: "",
  classes: "form-checkbox",
  value: "",
  disabled: false,
  children: <></>,
  required: false,
  onChange: () => {}
};

export default CheckboxInput;
